import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";

import Component from "./loadable";

export default injectIntl(connect(null, { post, editTask })(Component as any));
